import {
    STORE_USER_CONFIGURATION,
    UPDATE_TRUSTED_DEVICES_USER_CONFIGURATION,
} from '../../actions/userConfiguration';

export const defaultState = {
    hasTrustedDevice: false,
};

const trustedDevices = (state = defaultState, action = undefined) => {
    if (action.type === STORE_USER_CONFIGURATION) {
        return {
            hasTrustedDevice: action.payload.hasTrustedDevice !== undefined ? action.payload.hasTrustedDevice : state.hasTrustedDevice
        };
    }
    if (action.type === UPDATE_TRUSTED_DEVICES_USER_CONFIGURATION) {
        return {
            hasTrustedDevice: false
        };
    }

    return state;
};

export default trustedDevices;
